export default {
  methods: {
    /**
     * Callback action to add url to history stack.
     *
     * @param {string} url
     */
    addToHistoryStack(url) {
      window.history.pushState({}, '', url);
    },

    /**
      * Sets a URL with searchParams from a given object.
      *
      * Rejected key/value pairs:
      *  - empty string, or,
      *  - negative integer
      *
      * @param {url} string A relative url
      * @param {object} params A set of key/value pairs to set in new URL
      * @returns {URL} A URL with searchParams set.
      */
    setUrlSearchParams(url, params) {
      const newUrl = new URL(url, window.location);

      Object.keys(params).forEach(key => {
        if (this._isEmptyString(params[key])) return;
        if (this._isNegativeInteger(params[key])) return;

        newUrl.searchParams.set(key, params[key]);
      });

      return newUrl;
    },
    _isEmptyString(paramVal) {
      return paramVal === "";
    },
    _isNegativeInteger(paramVal) {
      return Number.isInteger(paramVal) && paramVal < 0;
    },
  }
};
